export default async function minifyJSON(input) {
  const jsonMinify = (await import('jsonminify')).default
  return jsonMinify(input)
}
